import { ConfigService } from './../../share/services/config.service';
import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { AuthService } from '../../share/services/auth.service';
import { AppService } from '../../app.service';
import { DatasetModel } from '../../share/models/dataset-model.model';
import { ApiService } from '../../share/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationReportModalComponent } from '../../share/modals/validation-report/validation-report-modal.component';
import FetrapiEnums from '../../share/enum/enums';
import { EventService } from '../../share/services/event.service';
import { SharedModule } from '../../share/shared.module';
import { SessionService } from '../../share/services/session.service';
const shareName = 'fetrapishare';

declare const L: any;

// TODO const serviceClient = new ShareServiceClient(environment.fetrapi.ShareServiceClient);



@Component({
  selector: 'app-zoidata',
  templateUrl: './zoidata.component.html',
  styleUrls: ['./zoidata.component.css'],
  imports: [SharedModule]
})
export class ZoidataComponent implements OnInit, AfterViewInit {
  private map!: L.Map;
  account: any; // TODO: fix any
  memberId: any; // TODO: fix any
  token: any; // TODO: fix any
  datasets: DatasetModel[] = [];
  isLoaded = false;
  isUploading = false;
  fileToUpload: File | undefined = undefined;
  datasetExtractType: string = '';
  stagingDataset: DatasetModel | undefined = undefined;
  loadedStaging = false;
  productionDataset: DatasetModel | undefined = undefined;
  loadedProduction = false;
  extractedDataset: DatasetModel | undefined = undefined;
  isStagingChecked = true;
  isProductionChecked = false;
  stagingLayer!: L.TileLayer;
  productionLayer!: L.TileLayer;
  allowUpload: boolean = false;

  private mapContainer!: ElementRef<HTMLElement>;

  FetrapiEnums = FetrapiEnums;

  constructor(
    private eventService: EventService,
    public appService: AppService,
    private api: ApiService,
    private auth: AuthService,
    private modalService: NgbModal,
    private configServide: ConfigService,
    private sessionService: SessionService
  ) {
    //Subscribe to the notification events
    this.eventService.getNotificationEvent().subscribe((notification) => {
      this.getmemberDatasets();
    });
  }

  ngOnInit(): void {
    this.getmemberDatasets();
  }

  getmemberDatasets() {
    this.api
      .getDataSets(
        '"' +
          FetrapiEnums.DatasetType.ZoI +
          '", "' +
          FetrapiEnums.DatasetType.Chapter3Export +
          '", "' +
          FetrapiEnums.DatasetType.ADCRExport +
          '"',
        '"' +
          FetrapiEnums.DatasetStatusCode.Active +
          '", "' +
          FetrapiEnums.DatasetStatusCode.ValidationSucceeded +
          '","' +
          FetrapiEnums.DatasetStatusCode.MemberApproved +
          '","' +
          FetrapiEnums.DatasetStatusCode.MemberRejected +
          '","' +
          FetrapiEnums.DatasetStatusCode.ValidationFailed +
          '","' +
          FetrapiEnums.DatasetStatusCode.ConfirmationRequired +
          '","' +
          FetrapiEnums.DatasetStatusCode.AdminRejected +
          '"'
      )
      .subscribe((data: any) => {
        this.datasets = data;
        console.log('results found: ' + this.datasets.length);
        console.log(data);
        const maingroupName = this.sessionService.getMaingroupName();
        this.datasetExtractType =
          maingroupName ==
          FetrapiEnums.MainGroups.ChIIIMember
            ? FetrapiEnums.DatasetType.Chapter3Export
            : FetrapiEnums.DatasetType.ADCRExport;
        this.getStagingDatasets();
        this.getProductionDatasets();

        //Check if there is validation report
        this.hasValidationReport(this.stagingDataset, (s: any) =>
          this.endLoading(s)
        );
      });
  }

  async ngAfterViewInit() {
    const jwtToken = await localStorage.getItem('jwttoken');
    if (jwtToken !== null) {
      this.token = jwtToken;
    }

    var l72_crs = new L.Proj.CRS('EPSG:31370',
    '+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs',
    {
      resolutions:[
        1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5
      ],
      origin: [14722.202449434262,20841.15747877769]
    });
    var URBISLayer = L.tileLayer.wms(
      this.configServide.getEnv('geoservicesBR'),
      {
        layers: 'urbisFR',
        transparent: true,
        format: 'image/png',
        opacity: 0.4,
      }
    );
    var PICCLayer = L.tileLayer.wms(
      this.configServide.getEnv('geoservicesWA'),
      {
        layers:
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29',
        transparent: true,
        format: 'image/png',
        opacity: 0.4,
      }
    );
    var GRBLayer = L.tileLayer.wms(this.configServide.getEnv('geoservicesFL'), {
      layers: 'GRB_BSK',
      transparent: true,
      format: 'image/png',
      opacity: 0.4,
    });
    this.stagingLayer = L.TileLayer.wmsHeader(
      this.configServide.getEnv('fetrapiApi') + 'GeoProxy?',
      { layers: 'FetrapiBaseData:vw_fet_zoi_stag_f', transparent: true, format: 'image/png' },
      [{ header: 'Authorization', value: "Bearer " + this.token }], null, null
    );
    this.productionLayer = L.TileLayer.wmsHeader(
      this.configServide.getEnv('fetrapiApi') + 'GeoProxy?',
      { layers: 'FetrapiBaseData:vw_fet_zoi_prod_f', transparent: true, format: 'image/png' },
      [{ header: 'Authorization', value: "Bearer " + this.token }], null, null
    );
    var backdrop = L.layerGroup([URBISLayer, PICCLayer, GRBLayer]);
    this.map = new L.Map('map', { crs: l72_crs, center: [50.5, 4.5], minZoom:1, maxZoom:11, zoom: 1, worldCopyJump: false, layers: [backdrop, this.stagingLayer] });
    var overlayMaps = {
      "URBIS": URBISLayer, "PICC": PICCLayer, "GRB": GRBLayer,
    };
    L.control.scale({ imperial: false, metric: true, position: 'bottomleft' }).addTo(this.map);
    L.control.layers(undefined, overlayMaps).addTo(this.map);
  }

  getDataset(filteredDatasets: DatasetModel[]): DatasetModel | undefined {
    let datasets = filteredDatasets.sort((a, b) => {
      return a.dateTimeCreated < b.dateTimeCreated ? 1 : -1;
    });

    if (datasets.length == 0) {
      return undefined;
    }

    if (datasets.length > 1) {
      console.log(
        'Detected more than one ' +
          datasets[0].statusCode +
          ' ' +
          datasets[0].datasetType +
          ' datasets'
      );
      console.log(datasets);
    }

    return datasets[0];
  }

  getExtractedDataset() {
    this.extractedDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.Active &&
          (x.datasetType == FetrapiEnums.DatasetType.ADCRExport ||
            x.datasetType == FetrapiEnums.DatasetType.Chapter3Export)
      )
    );
  }

  getStagingDatasets() {
    this.stagingDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode != FetrapiEnums.DatasetStatusCode.ConfirmationRequired &&
          x.statusCode != FetrapiEnums.DatasetStatusCode.Active  &&
          x.datasetType == FetrapiEnums.DatasetType.ZoI
      )
    );

    if (this.stagingDataset == null) {
      this.allowUpload = true;
    } else {
      switch (this.stagingDataset.statusCode) {
        case FetrapiEnums.DatasetStatusCode.ValidationSucceeded:
          this.allowUpload = false;
          break;
        case FetrapiEnums.DatasetStatusCode.ValidationFailed:
        case FetrapiEnums.DatasetStatusCode.MemberApproved:
        case FetrapiEnums.DatasetStatusCode.MemberRejected:
        case FetrapiEnums.DatasetStatusCode.AdminRejected:
          this.allowUpload = true;
          break;
        default:
          this.allowUpload = true;
          break;
      }
    }

    //Reload stagingLayer map
    if (this.isStagingChecked) {
      console.log('reloading stagingLayer map');
      if (this.stagingLayer) {
        this.map.removeLayer(this.stagingLayer);
        this.map.addLayer(this.stagingLayer);
        this.SetZIndex();
      }
    }
  }

  getProductionDatasets() {
    this.productionDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          (
            x.statusCode == FetrapiEnums.DatasetStatusCode.Active ||
            x.statusCode == FetrapiEnums.DatasetStatusCode.ConfirmationRequired
          ) &&
          x.datasetType == FetrapiEnums.DatasetType.ZoI
      )
    );

    this.getExtractedDataset();

    //Reload productionLayer map
    if (this.isProductionChecked) {
      console.log('reloading productionLayer map');
      this.map.removeLayer(this.productionLayer);
      this.map.addLayer(this.productionLayer);
      this.SetZIndex();
    }
  }

  endLoading(endLoading: boolean) {
    this.isLoaded = endLoading;
    this.loadedStaging = endLoading;
    this.loadedProduction = endLoading;
  }

  hasValidationReport(dataset: DatasetModel | undefined, callback: any) {
    if (dataset == undefined) {
      if (callback) {
        callback(true);
      }

      return;
    }

    this.api.hasValidationReport(dataset.datasetId).subscribe({
      next: (data: any) => {
        dataset.hasValidationReport = data;

        if (callback) {
          callback(true);
        }
      },
      error: (error: any) => {
        if (error.status != 404) {
          this.api.errorhandler(error);
        }
        if (callback) {
          callback(true);
        }
      },
    });
  }

  downloadExtractedDataset(datasetId: string) {
    this.downloadDataset(datasetId);
  }

  downloadValidationReport(datasetId: string | undefined) {
    if (datasetId) {
      this.api.getValidationReport(datasetId).subscribe((data: any) => {
        const modal = this.modalService.open(ValidationReportModalComponent);
        modal.componentInstance.showValidationReport(data);
      });
    }
  }

  downloadDataset(datasetId: string| undefined) {
    if (datasetId) {
      this.api.downloadDataset(datasetId).subscribe({
        next: (data: any) => {
          const element = document.createElement('a');
          element.href = data;
          document.body.appendChild(element);
          element.click();
        },
        error: (error: any) => {
          if (error.status == 404) {
            this.appService.showModalError(error.error.message);
          } else {
            this.api.errorhandler(error);
          }
        },
      });
    }
  }

  confirmDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberConfirmed
    );
  }


  ApproveDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberApproved
    );
  }

  RejectDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberRejected
    );
  }

  changeDatasetStatus(datasetId: string, statusCode: FetrapiEnums.DatasetStatusCode) {
    this.api.updateDatasetStatus(datasetId, statusCode).subscribe({
      next: (data: any) => {
        this.getmemberDatasets();
      },
      error: (error: any) => {
        if (error.status == 404 || error.status == 400) {
          this.appService.showModalError(error?.error?.message);
        } else {
          this.api.errorhandler(error);
        }
      },
    });
  }

  handleFileInput(event: Event) {
    const files: FileList | null = (event.target as HTMLInputElement).files;
    if (files !== null && files.item(0) !== null) {
      this.fileToUpload = files.item(0) as File;
    }
    console.log(this.fileToUpload);
    this.uploadDataset();
  }


  async uploadDataset() {
    this.isUploading = true;
    const memberid = this.sessionService.getMaingroupGId();
    var memberidmin = memberid.replace(/-/g, '');
    console.log('memberid: ' + memberidmin);
    if (this.fileToUpload != null && memberidmin != null) {
      this.api.ZoIData(this.fileToUpload).subscribe({
        next: (data: any) => {
          this.getmemberDatasets();
          this.isUploading = false;
        },
        error: (error: any) => {
          this.isUploading = false;
          if (error.status == 400) {
            this.appService.showModalError(error.error.message);
            this.getmemberDatasets();
          } else {
            this.api.errorhandler(error);
          }
        },
      });
    }
    this.fileToUpload = undefined;
  }

  ToggleStaging() {
    console.log(
      'Switching Staging Datasets from ' +
        this.isStagingChecked +
        ' to ' +
        !this.isStagingChecked
    );
    this.isStagingChecked = !this.isStagingChecked;
    if (this.isStagingChecked == true) {
      this.map.addLayer(this.stagingLayer);
      this.SetZIndex();
    }
    if (this.isStagingChecked == false) {
      this.map.removeLayer(this.stagingLayer);
    }
  }

  ToggleProduction() {
    console.log(
      'Switching Production Datasets from ' +
        this.isProductionChecked +
        ' to ' +
        !this.isProductionChecked
    );
    this.isProductionChecked = !this.isProductionChecked;
    if (this.isProductionChecked == true) {
      this.map.addLayer(this.productionLayer);
      this.SetZIndex();
    }
    if (this.isProductionChecked == false) {
      this.map.removeLayer(this.productionLayer);
    }
  }

  SetZIndex() {
    if (this.isProductionChecked) {
      this.productionLayer.bringToFront();
    }
    if (this.isStagingChecked) {
      this.stagingLayer.bringToFront();
    }
  }

}
